var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-main"},[_c('img',{attrs:{"src":require("@/assets/img/pay-result-icon.png"),"alt":""}}),_c('p',{staticClass:"txt"},[_vm._v(_vm._s(_vm.$t("shop.paysuccess")))]),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.$t("shop.payreturndesc",{num:_vm.index}))),_c('span',{staticClass:"loading"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }